export default "__VITE_ASSET__Dc7qJz3M__"